/*
 * fn: getCardImage
 *
 * Gets the image URL from a scryfallId
 *
 */
import { CARD_IMAGE_BASE } from '@/defs/misc'

type Props = {
  face?: 'front' | 'back'
  path?: 'art' | 'grid'
  scryfallId?: string
}

export const getCardImage = ({ face = 'front', path = 'grid', scryfallId }: Props) =>
  !scryfallId ? undefined : `${CARD_IMAGE_BASE}/${path}/${face}/${scryfallId[0]}/${scryfallId[1]}/${scryfallId}.webp`
